import { z } from 'zod';

const itemStatusEnum = z.enum([
  'not_started',
  'inquired',
  'quoted',
  'contract_requested',
  'booked',
]);

export const createItemSchema = z.object({
  categoryId: z.string().uuid('Invalid category ID'),
  name: z.string().min(1, 'Item name is required').max(255),
  notes: z.string().max(2000).nullable().optional(),
  estimatedCost: z.number().int().min(0).nullable().optional(),
  sortOrder: z.number().int().min(0).optional().default(0),
  vendorId: z.string().uuid().nullable().optional(),
  vendorContactName: z.string().max(255).nullable().optional(),
  vendorEmail: z.string().email().max(255).nullable().optional(),
  vendorPhone: z.string().max(50).nullable().optional(),
  vendorWebsite: z.string().url().max(2048).nullable().optional(),
});

export const updateItemSchema = z.object({
  name: z.string().min(1, 'Item name is required').max(255).optional(),
  status: itemStatusEnum.optional(),
  notes: z.string().max(2000).nullable().optional(),
  estimatedCost: z.number().int().min(0).nullable().optional(),
  sortOrder: z.number().int().min(0).optional(),
  categoryId: z.string().uuid('Invalid category ID').optional(),
  vendorId: z.string().uuid().nullable().optional(),
  vendorContactName: z.string().max(255).nullable().optional(),
  vendorEmail: z.string().email().max(255).nullable().optional(),
  vendorPhone: z.string().max(50).nullable().optional(),
  vendorWebsite: z.string().url().max(2048).nullable().optional(),
  isSelectedForProject: z.boolean().optional(),
});

export type CreateItemInput = z.input<typeof createItemSchema>;
export type UpdateItemInput = z.input<typeof updateItemSchema>;

export const sendInquirySchema = z.object({
  subject: z.string().min(1, 'Subject is required').max(500),
  body: z.string().min(1, 'Body is required').max(10000),
  vendorId: z.string().uuid().nullable().optional(),
  vendorContactId: z.string().uuid().nullable().optional(),
});

export type SendInquiryInput = z.input<typeof sendInquirySchema>;
